import * as React from "react";
import {
  Button,
  Grid,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
  Paper as MuiPaper,
  MenuItem,
  Select,
  CircularProgress,
  Checkbox,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  FormControlLabel,
  Switch,
  OutlinedInput,
  InputAdornment,
  FormLabel,
  RadioGroup,
  Radio,
  Tooltip,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";

export default function CreateNfsePaymentComponent({ createCompoment }) {
  let { getApi, postApi, user, signUpStep2, isBSAccount, isInitializedBS } =
    useAuth();

  let { catalogId, catalogList, itensCobranca, setItensCobranca } =
    createCompoment;

  const [tabVal, setTabVal] = React.useState(0);

  const setCatalogId = (id, val) => {
    let index = itensCobranca.findIndex((x) => x.id == id);
    itensCobranca[index].catalogId = val;
    setItensCobranca([...itensCobranca]);
  };

  return (
    <React.Fragment>
      {itensCobranca.map((el, index) => (
        <Grid container spacing={6} md={12}>
          <Grid item md={4}>
            <FormControl sx={{ m: 1, width: "25ch" }}>
              <TextField
                label="Item da cobrança"
                variant="outlined"
                fullWidth
                required
                value={
                  el.description ? index + 1 + " - " + el.description : null
                }
                my={2}
                key={el.description}
                disabled={true}
              />
               <Typography
                      variant="caption"
                      display="flex"
                      alignItems="center"
                    >
                   {index+1}º item da cobrança
                      <Tooltip title="Item da cobrança relacionado ao serviço prestado.">
                        <HelpOutlineIcon
                          fontSize="small"
                          style={{ marginLeft: 4, cursor: "pointer" }}
                        />
                      </Tooltip>
                    </Typography>
            </FormControl>
          </Grid>
          <Grid item md={4}>
            <FormControl sx={{ m: 1, width: "25ch" }}>
              <InputLabel id="demo-simple-select-label">
                Selecione o Catálogo
              </InputLabel>
              <Select
                fullWidth
                required
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Nome do Produto/Serviço"
                onChange={(e) => setCatalogId(el.id, e.target.value)}
                value={el.catalogId}
              >
                {catalogList.length > 0 &&
                  catalogList.map((el) => (
                    <MenuItem value={el.id}>{el.name}</MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={4}>
            <FormControl sx={{ m: 1, width: "25ch" }}>
              <TextField
                variant="outlined"
                fullWidth
                required
                value={
                  catalogList.find((x) => x.id == el.catalogId)?.nfse?.aliq_iss
                }
                my={2}
                disabled={true}
                key={el.catalogId}
              />
            </FormControl>
          </Grid>
        </Grid>
      ))}


    </React.Fragment>
  );
}
